import React, {useEffect, useRef, useState} from "react";
import {ATTEndpoints} from "../../../../../services/att/endpoints";
import CustomDataGrid, {DataGridRef} from "../../../../../components/data-grid/CustomDataGrid";
import {
  GridColDef,
} from "@mui/x-data-grid";
import {Box, Grid, Stack, TextField,} from "@mui/material";
import {useTranslation} from "react-i18next";
import WebURL from "@/urls";
import CustomBreadcrumbs from "@/components/breadcrumbs/CustomBreadcrumbs";
import SnackbarUtil from "@/utils/SnackbarUtil";
import CustomRowButton from "@/components/data-grid/CustomRowButton";
import {ReactComponent as IconEdit} from "@/assets/icons/IconEdit.svg";
import {ReactComponent as IconDeletes} from "@/assets/icons/IconDeletes.svg";
import Dialog from "@/components/dialog";
import {useNavigate} from "react-router-dom";
import MobileService from "@/services/att/services/MobileService";
import NewAddress from "@/pages/att/Timecard/components/ClockAddress/components/NewAddress";
import {useLocation} from 'react-router-dom';


const ClockAddressGrid: React.FC = () => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const dataGridRef = useRef<DataGridRef>();
  const location = useLocation();
  useEffect(() => {
    reloadTable();

    if (location.state?.needRefresh) {
      reloadTable();
      location.state.needRefresh = false;
    }
  }, [location.state?.needRefresh]);


  const columns: GridColDef[] = [
    {
      field: 'gps_location', headerName: t("common.address"), minWidth: 300, flex: 0.3, filterable: false,
    },
    {
      field: 'clock_range',
      headerName: t("common.clock range"),
      type: "string",
      minWidth: 100,
      flex: 0.2,
      filterable: false
    },
    {
      field: 'use_scope', headerName: t("common.scope of use"), type: "string", minWidth: 200, flex: 0.3,
    },
    {
      field: 'timezone', headerName: t("att.schedule.TimeZone"), type: "string", minWidth: 100, flex: 0.2,
    },

    // {field: 'timezone', headerName: t("att.schedule.TimeZone"), minWidth: 100, flex: 0.2},
    {
      field: 'actions', flex: 0.2, headerName: t("common.action"), headerAlign: 'left', align: 'left',
      sortable: false,
      renderCell: (e) => {
        return (
          <Stack direction={"row"}>
            <Grid sx={{marginLeft: "-5px"}}>
              <CustomRowButton
                insideSvgIcon={IconEdit}
                actionName={t("common.edit")}
                buttonProps={{
                  key: "edit",
                  onClick: () => {
                    // locationViewRef?.current?.showDetail(e.row.id)
                    navigate(WebURL.ATT_CLOCK_ADDRESS_EDIT, {state: {id: e.row.id}});
                  }
                }}
              />
            </Grid>
            <Grid>
              <CustomRowButton
                insideSvgIcon={IconDeletes}
                actionName={t("common.delete")}
                buttonProps={{
                  key: "delete",
                  onClick: () => (
                    Dialog.confirm({
                      title: t("common.Delete Location?"),
                      content: t("common.deleteConfirm"),
                      onConfirm: () => {
                        MobileService.destroy((e.id).toString()).then(
                          (result) => {
                            SnackbarUtil.success(t('common.success'));
                            dataGridRef.current?.refresh();
                          });
                      }
                    })
                  )
                }}
              />
            </Grid>
          </Stack>
        )
      }
    }
  ]
  const reloadTable = () => {
    dataGridRef.current?.refresh();
  }

  const toolbar = {
    title: t("common.Mobile Punch Setting"),
    searchTips: t("common.Search by Address"),
    search: true,
    // info: {setDisplay: setInfo,},
    breadcrumbs: [
      {breadcrumbName: t("common.Mobile Punch Setting"), path: WebURL.ATT_CLOCK_ADDRESS}
    ],
    actions: [{
      key: 'add', iconFont: 'icon-ic_add', helpTxt: t("common.add"), callback: async () => {
        // locationViewRef?.current?.showDetail()
        navigate(WebURL.ATT_CLOCK_ADDRESS_NEW);
      }
    }],
  }

  return (
    <>
      <Box
        sx={{
          '& .MuiDataGrid-row-height-no-limit': {
            maxHeight: '180px!important'
          },
        }}
      >
        <CustomBreadcrumbs record={[{label: t("common.Mobile Punch Setting")}]}/>
        <CustomDataGrid
          columns={columns}
          ref={dataGridRef}
          uri={ATTEndpoints.MOBILE_LOCATION_DETAIL}
          toolbar={toolbar}
          localeText={{
            filterPanelColumns: t("common.Columns"),
            filterPanelOperators: t("common.Operators"),
          }}
        />
        {/*<NewAddress ref={locationViewRef} reloadTable={reloadTable}></NewAddress>*/}
      </Box>
    </>
  )
}
export default ClockAddressGrid
